import { HostBinding, Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: 'input'
})
export class InputDirective {
    @HostBinding('attr.autocomplete') _autocomplete = 'off'
   
    @HostListener('click') _onClick() { }
    @HostListener('focus') _onfocus() {(<HTMLInputElement>this._element.nativeElement).select(); }

   // @HostListener('keyup') onKeyUp() { (<HTMLInputElement>this._element.nativeElement).value =  (<HTMLInputElement>this._element.nativeElement).value.toUpperCase() }

   constructor(public _element: ElementRef) { }

}
